import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { PageTitleStrategy } from './page-title-strategy';
import { LnrOktaCallbackPage } from './pages/lnr-okta-callback/lnr-okta-callback.page';
import { OktaCallbackGuard } from './shared/guards/okta-callback/okta-callback.guard';
import { UserGuard } from './shared/guards/user/userGuard';
import { RoutesKeys } from './utils/routes';

const routes: Routes = [
  {
    path: RoutesKeys.LOGIN_CALLBACK,
    component: LnrOktaCallbackPage,
    canActivate: [OktaCallbackGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    canLoad: [OktaAuthGuard, UserGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: TitleStrategy,
      useClass: PageTitleStrategy,
    },
  ],
})

/**
 * AppRoutingModule
 */
export class AppRoutingModule {}
